import { concernColors } from '../constants';

const TEXT_SHADOW_STYLE =
  'text-shadow: 0.05em 0 black, 0 0.05em black, -0.05em 0 black, 0 -0.05em black, -0.05em -0.05em black, -0.05em 0.05em black, 0.05em -0.05em black, 0.05em 0.05em black;';

// Accessibility indicators for concern levels
const concernIndicators = {
  'Extremely Concerning': '⚠️ CRITICAL:',
  'Very Concerning': '🔴 HIGH:',
  'Moderately Concerning': '🟠 MEDIUM:',
  'Mildly Concerning': '🟡 LOW:',
  'No Concern': '✅ NONE:',
};

export function applyReportStyling(reportText) {
  if (!reportText) return null;

  const concernPattern =
    /\((Very Concerning|Moderately Concerning|Mildly Concerning|No Concern|Extremely Concerning)\)/g;

  return reportText.replace(concernPattern, (match, concernLevel) => {
    const color = concernColors[concernLevel] || 'black';
    const indicator = concernIndicators[concernLevel] || '';
    return `<span style="color: ${color}; ${TEXT_SHADOW_STYLE}">${indicator} ${concernLevel}</span>`;
  });
}
